import { render, staticRenderFns } from "./categoryMenu.vue?vue&type=template&id=02a83c3e&scoped=true&"
import script from "./categoryMenu.vue?vue&type=script&lang=js&"
export * from "./categoryMenu.vue?vue&type=script&lang=js&"
import style0 from "./categoryMenu.vue?vue&type=style&index=0&id=02a83c3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a83c3e",
  null
  
)

export default component.exports